import React from 'react';
import './home.css'
import '../../App.css'
import InViewComponent from '../../screens/components/InView';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../hook/UseLang';
import CONTENT from '../../contents/home'
import BTN from '../../contents/btn'
const Home2 = () => {
    const navigate = useNavigate()
    const text1Ref = React.useRef(null);
    const text2Ref = React.useRef(null);
    const text3Ref = React.useRef(null);
    const text4Ref = React.useRef(null);
    const text5Ref = React.useRef(null);
    const [lang, setLang] = useLang();
    return (
        <div id='contact' className='w-full min-h-[90vh] relative'>
            <img src='./images/home/reserve.jpg' className='absolute top-0 left-0 w-full h-full' style={{objectFit: 'cover', zIndex:1}}></img>
            <div className='absolute top-0 left-0 w-full h-full bg-[#FFFFFF] opacity-[0.8]' style={{objectFit: 'cover', zIndex:2}} />
            <div className='relative w-full h-full flex flex-row items-center justify-center' style={{zIndex:3}}>
                <div className='w-full h-[60%] flex flex-col items-center justify-center'>
                    <div ref={text1Ref} className='text-homesec-title title_text playfair-display' style={{letterSpacing:5}}>{CONTENT.sec6_0[lang]}</div>
                    <InViewComponent reffing={text1Ref} active='title_text_active' />
                    {/* <div className='flex flex-col items-center justify-center relative min-w-[300px] w-[70%] mt-[50px]'>
                        <div className='w-full h-full absolute bg-white opacity-[0.7]' style={{zIndex:1}}></div>
                        <div className='relative w-full py-[48px]' style={{zIndex:2}}>
                            <div className='flex flex-col items-center' style={{gap:12}}>
                                <div className='text-[#0FBAB5]'>Address</div>
                                <div ref={text2Ref} className='title_text'>No. 21, Whitfield Road, Causeway Bay, Hong Kong Island, Hong Kong</div>
                                <InViewComponent reffing={text2Ref} active='title_text_active' />
                            </div>
                            <div className='flex flex-col items-center mt-[54px]' style={{gap:12}}>
                                <div className='text-[#0FBAB5]'>Email</div>
                                <div ref={text3Ref} className='title_text'>info@21whitfieldseaview.com</div>
                                <InViewComponent reffing={text3Ref} active='title_text_active' />
                            </div>
                            <div className='flex flex-col items-center mt-[54px]' style={{gap:12}}>
                                <div className='text-[#0FBAB5]'>Telephone</div>
                                <div ref={text4Ref} className='title_text'>+852 39948585</div>
                                <InViewComponent reffing={text4Ref} active='title_text_active' />
                            </div>
                            <div className='flex flex-col items-center mt-[54px]' style={{gap:12}}>
                                <div className='text-[#0FBAB5]'>MTR Station</div>
                                <div ref={text5Ref} className='title_text'>Tin Hau</div>
                                <InViewComponent reffing={text5Ref} active='title_text_active' />
                            </div>
                        </div>
                    </div> */}
                    {/* <div className='px-[89px] mt-[50px] py-[6px] bg-[#0FBAB5] text-white select-none cursor-pointer playfair-display hover:bg-[#9B998F] transition-all duration-300'>book now</div> */}
                    <a target='_blank' href={`https://book-directonline.com/properties/twentyonewhitfield`} className='mt-[50px] h-[89px] w-[90%] max-w-[520px] bg-[#0FBAB5] text-white text-[35px] select-none cursor-pointer playfair-display hover:bg-[#9B998F] transition-all duration-300 flex items-center justify-center'>{BTN.book_now[lang]}</a>
                    <div ref={text2Ref} className='text-d-12 title_text mt-[18px]' >{CONTENT.sec6_1[lang]}</div>
                    <InViewComponent reffing={text2Ref} active='title_text_active' />
                    <div ref={text3Ref} className='title_text text-d-12 mt-[12px]' >{CONTENT.sec6_3[lang]}<span className='text-d-20'>info@21whitfieldseaview.com</span></div>
                    <div ref={text3Ref} className='title_text text-d-12 mt-[4px]' >{CONTENT.sec6_2[lang]}<span className='text-d-20'>+852 39948585</span></div>
                    <InViewComponent reffing={text3Ref} active='title_text_active' />
                </div>
            </div>
        </div>
    );
};

export default Home2;